const overrides = (palette, typography) => ({
  root: {
    backgroundColor: palette.action.disabledBackground
  }
})

export default overrides
